import type { CategoryDefinition } from '@/types';

export const lawnCareCategories: readonly CategoryDefinition[] = [
  { id: 'lawn-care.maintenance', name: 'Maintenance', icon: 'leaf',    color: 'green',   order: 1, description: 'Recurring rounds priced by area' },
  { id: 'lawn-care.trimming',    name: 'Trimming',    icon: 'trees',   color: 'emerald', order: 2, description: 'Hedges, shrubs and trees' },
  { id: 'lawn-care.planting',    name: 'Planting',    icon: 'sprout',  color: 'lime',    order: 3, description: 'New growth and bed preparation' },
  { id: 'lawn-care.cleanup',     name: 'Cleanup',     icon: 'recycle', color: 'teal',    order: 4, description: 'Clearance and waste removal' },
];
